import { render, staticRenderFns } from "./PricingFeatures.vue?vue&type=template&id=694ba143&scoped=true&"
import script from "./PricingFeatures.vue?vue&type=script&lang=js&"
export * from "./PricingFeatures.vue?vue&type=script&lang=js&"
import style0 from "./PricingFeatures.vue?vue&type=style&index=0&id=694ba143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694ba143",
  null
  
)

export default component.exports